import { createContext } from 'react';

/**
 * The DOM element next to a tool's page title (or null), so a tool can portal a small status chip there
 * (e.g. the loaded vehicle / setup) without the shared page knowing about it.
 */
export const ToolTitleSlotContext = createContext(null);
